export default function (win, n, v, op) {
  if (typeof window === 'undefined') {
    return
  }
  if (typeof win === 'string') {
    op = v
    v = n
    n = win
    win = window
  }
  if (v !== undefined) {
    op = op || {}
    let date
    let expires = ''
    if (op.expires) {
      if (op.expires.constructor === Date) {
        date = op.expires
      } else {
        date = new Date()
        date.setTime(date.getTime() + (op.expires * 24 * 60 * 60 * 1000))
      }
      expires = '; expires=' + date.toGMTString()
    }
    const path = op.path ? '; path=' + op.path : ''
    const domain = op.domain ? '; domain=' + op.domain : ''
    const secure = op.secure ? '; secure' : ''
    win.document.cookie = [n, '=', encodeURIComponent(v), expires, path, domain, secure].join('')
  } else {
    v = win.document.cookie.match(new RegExp('(?:\\s|^)' + n + '\\=([^;]*)'))
    return v ? decodeURIComponent(v[1]) : null
  }
}
